import { BaseActionObject, EventObject, NoInfer, StatesConfig } from "xstate";

export function MiddleWareFinalState<
  Context,
  EventType extends EventObject,
  Action extends BaseActionObject
>(
  states?: StatesConfig<NoInfer<Context>, any, NoInfer<EventType>, Action>
): StatesConfig<NoInfer<Context>, any, NoInfer<EventType>, Action> {
  let statesDefine = {} as any;
  const finalState = {
    type: "final",
  };
  if (states) {
    for (let i = 0; i < Object.keys(states).length; i++) {
      const key = Object.keys(states)[i];
      statesDefine[key] = Object.values(states)[i];
    }
    statesDefine = { ...statesDefine, final: finalState };
  }
  return statesDefine;
}
